import { type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-surface-2 dark:bg-surface-3",
        className,
      )}
      aria-hidden
      {...props}
    />
  );
}
